module.exports={account_link_complete_message:"Nexon-Account-Verknüpfung ist abgeschlossen."};